var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CChartBar',{attrs:{"datasets":_vm.defaultDatasets,"labels":"months"}})
}
var staticRenderFns = []

export { render, staticRenderFns }